import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 26.996a2 2 0 0 1-1.995-1.85L2 24.996V13.998a2 2 0 0 1 1.85-1.994l.15-.006h5.38l4.724-9.445A1 1 0 0 1 14.998 2a5 5 0 0 1 4.992 4.735l.007.264v2h6.733a3 3 0 0 1 2.113.87l.136.144a3 3 0 0 1 .746 2.16l-.018.197-1.5 11.999a3 3 0 0 1-2.796 2.622l-.18.005zM15.586 4.058l-4.587 9.175v11.763H25.23a1 1 0 0 0 .971-.762l.02-.114 1.5-11.998a1 1 0 0 0-.87-1.116l-.122-.007h-7.733a1 1 0 0 1-.993-.884L17.997 10v-3a3 3 0 0 0-2.22-2.897zm-6.587 9.94h-5v10.998h5z"
    />
  </svg>
);
const SvgIconThumbsUp = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconThumbsUp);
export default Memo;
